import axios from 'axios';

export async function getVersion() {
  try {
    const res = await axios.get('/api/version');
    return res.data?.version || '0.0.0';
  } catch {
    return '0.0.0';
  }
}

export default { getVersion };
